
<template>
	<div :class="columnClass">
        <div v-if="columnLabel=='employee_name'" class="table-td-border-right">
            <div class="calls-table-cell-inner-table o-modal-trigger" data-toggle="modal" data-target="#employeeSummaryModal">

                <div class="o-accordion-subtext o-rowtable-text">

                    <div>{{(selectedSortType=='fname_asc')?employee.first_name+" "+employee.last_name : employee.last_name+", "+employee.first_name}}</div>
                </div>
            </div>
        </div>

        <div v-if="columnLabel=='employee_seniority'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">

                <div>{{ getRoundOffSkillSeniority(employee.employee_seniority) || 0}}</div>
            </div>
        </div>

        <div v-if="columnLabel=='skill_seniority'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">

                <div>{{ getRoundOffSkillSeniority(employee.skill_seniority) || 0 }}</div>
            </div>
        </div>

        <div v-if="columnLabel=='shift_count_ytd'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.total_shift_YTD || '0' }}</div>
            </div>
        </div>

        <div v-if="columnLabel=='shift_count_total'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.total_shifts || '0' }}</div>
            </div>
        </div>

        <div v-if="columnLabel=='shifts_this_week'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.total_shift_weekly || '0' }}</div>
            </div>
        </div>

        <div v-if="columnLabel=='shifts_ytd_july_june'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.total_shift_july_june || '0' }}</div>
            </div>
        </div>

        <div v-if="columnLabel=='declines_total'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.total_decline || '0' }}</div>
            </div>
        </div>

        <div v-if="columnLabel=='declines_ytd'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.total_decline_YTD || '0' }}</div>
            </div>
        </div>

        <div v-if="columnLabel=='declines_ytd_july_june'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.total_decline_july_june || '0' }}</div>
            </div>
        </div>

        <div v-if="columnLabel=='decline_this_week'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.total_decline_weekly || '0' }}</div>
            </div>
        </div>

        <div v-if="columnLabel=='participation'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{getParticipation(employee.participation)}} %</div>
            </div>
        </div>

        <div v-if="columnLabel=='participation_july_june_desc'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{getParticipationJulyJune(employee.participation_july_june)}} %</div>
            </div>
        </div>

        <div v-if="columnLabel=='last_offer'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.last_offer ? getGloabalDateTimeFormat(employee.last_offer) : ""}}</div>
            </div>
        </div>

        <div v-if="columnLabel=='last_assigned'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.last_assigned ? getGloabalDateTimeFormat(employee.last_assigned) : ""}}</div>
            </div>
        </div>

        <div v-if="columnLabel=='last_confirmed'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.last_confirmed ? getGloabalDateTimeFormat(employee.last_confirmed) : ""}}</div>
            </div>
        </div>

        <div v-if="columnLabel=='member_since'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.member_since ? getGloabalDateFormat(employee.member_since) : ""}}</div>
            </div>
        </div>

        <div v-if="columnLabel=='date_of_hire'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <!-- {{ employee.employee_date_of_hire }} -->
                <div>{{employee.date_of_hire ? getGloabalDateFormat(employee.date_of_hire) : ""}}</div>
            </div>
        </div>

        <div v-if="columnLabel=='location'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.address || '- - -'}}</div>
                <!-- <div>Add Location</div> -->
            </div>
        </div>

        <div v-if="columnLabel=='wishlist'" class="table-td-border-right calls-table-cell-inner-table">
            <div class="o-accordion-subtext o-rowtable-text">
                <span>
                    Wishlist:
                    <el-tooltip v-if="employee.wishlist&&employee.wishlist.length&&employee.wishlist[0].employee_message" class="item" effect="light" :content="employee.wishlist[0].employee_message" placement="top-end">
                        <i :class="(employee.wishlist.length==0)?'fa fa-star fa-star--disable':((employee.wishlist[0].type !='W') ? 'fa fa-ban' : 'fa fa-star')" aria-hidden="true"></i>
                    </el-tooltip>
                    <i v-else-if="employee.wishlist&&employee.wishlist.length" :class="(employee.wishlist.length==0)?'fa fa-star fa-star--disable':((employee.wishlist[0].type !='W')? 'fa fa-ban' : 'fa fa-star')" aria-hidden="true"></i>
                </span>
                <div>{{(employee && employee.wishlist.length)? getTimeStampValue(employee.wishlist[0].wishlist_timing):''}}</div>
            </div>
        </div>

        <div v-if="columnLabel=='custom_field1'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{getCustomField(employee.custom_field1)}}</div>
            </div>
        </div>

        <div v-if="columnLabel=='custom_field2'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{getCustomField(employee.custom_field2)}}</div>
            </div>
        </div>

        <div v-if="columnLabel=='employee_cell_phone'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>
                    <a :href="'tel:'+getClientContactFormat(employee.phone_number)" class="phone-number-display">
                        {{ employee.phone_number ? getClientContactFormat(employee.phone_number) : '' }}
                    </a>
                </div>
            </div>
        </div>

        <div v-if="columnLabel=='conflicts'">
            <div v-if="checkVacationWithinCall(employee.vacations) || recurringUnavailability(employee.available_times)" class="table-td-border-right calls-table-cell-inner-table">
                <div class="o-tags u-no-padding text-right o-tag-btn-container">
                    <ul class="o-tag-btn-area o-float-right">
                        <li class="o-half-div">
                            <a href="javascript: void(0)" class="c-tag-btn u-btn-red">
                                {{ recurringUnavailability(employee.available_times) && checkVacationWithinCall(employee.vacations)
                                ?
                                'Unavailable due to vacation and recurring unavailability'
                                :
                                recurringUnavailability(employee.available_times)
                                ?
                                'Unavailable due to recurring unavailability'
                                :
                                'Unavailable due to vacation' }}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            <div v-else-if="employee.bookings.length == 0 && !checkVacationWithinCall(employee.vacations) && !recurringUnavailability(employee.available_times) && !getDeclineStatus(employee.call_actions) && !getPassStatus(employee.call_actions) && !getTimeOutStatus(employee.call_actions) && !getCallOutStatus(employee.call_actions)" class="table-td-border-right calls-table-cell-inner-table">
                <div class="o-tags u-no-padding text-right o-tag-btn-container">

                    <ul v-if="!employee.previous_calls&&!employee.next_calls" class="o-tag-btn-area o-float-right">
                        <li class="">
                            <a href="javascript: void(0)" class="o-half-div c-tag-btn u-btn-green">
                                Last call: 24:00+
                            </a>
                            <a href="javascript: void(0)" v-if="employee.hts&&employee.hts.length && !isCurrentJobHTS(employee.hts)" class="o-half-div c-tag-btn u-btn-light-orange">
                                {{ getJobTitle(employee.hts) }}
                            </a>
                            <a href="javascript: void(0)" class="o-half-div c-tag-btn u-btn-green">
                                Nex call: 24:00+
                            </a>
                        </li>
                    </ul>

                    <ul v-else-if="!getDeclineStatus(employee.call_actions) && !getPassStatus(employee.call_actions)" class="o-tag-btn-area o-float-right">

                        <li v-if="Object.keys(employee.previous_calls).length==0" :class="{'o-half-div': true, 'o-half-div-width': !isCurrentJobHTS(employee.hts)}">
                            <a href="javascript: void(0)" :class="{'c-tag-btn u-btn-blue':(Object.keys(employee.hts).length>0 && isCurrentJobHTS(employee.hts)), 'c-tag-btn u-btn-light-orange':(Object.keys(employee.hts).length>0 && !isCurrentJobHTS(employee.hts)), 'c-tag-btn u-btn-green':(Object.keys(employee.hts).length==0)}">Last call: 24:00+</a>
                        </li>

                        <li v-if="Object.keys(employee.previous_calls).length!=0" :class="{'o-half-div': true, 'o-half-div-width': !isCurrentJobHTS(employee.hts)}">
                            <a href="javascript: void(0)" :class="{'c-tag-btn u-btn-blue':(Object.keys(employee.hts).length>0 && isCurrentJobHTS(employee.hts)), 'c-tag-btn u-btn-light-orange':(Object.keys(employee.hts).length>0 && !isCurrentJobHTS(employee.hts)), 'c-tag-btn u-btn-green':(Object.keys(employee.hts).length==0 && !checkTurnOver(employee.previous_calls)), 'c-tag-btn u-btn-yellow':(Object.keys(employee.hts).length==0 && checkTurnOver(employee.previous_calls)),'u-btn-border-red':checkPrevNextCallSameDay(employee.prev_Call)}">
                                {{ getPrevCallTime(employee.previous_calls) }}
                            </a>
                        </li>

                        <li v-if="employee.hts&&employee.hts.length && !isCurrentJobHTS(employee.hts)" class="o-half-div o-half-div-width">   
                            <a href="javascript: void(0)" class="c-tag-btn u-btn-light-orange">
                                {{getJobTitle(employee.hts)}}
                            </a>
                        </li>

                        <li v-if="employee.next_calls&&Object.keys(employee.next_calls).length==0" :class="{'o-half-div':  true, 'o-half-div-width': !isCurrentJobHTS(employee.hts)}">
                            <a href="javascript: void(0)" :class="{'c-tag-btn u-btn-blue':(Object.keys(employee.hts).length>0 && isCurrentJobHTS(employee.hts)), 'c-tag-btn u-btn-light-orange':(Object.keys(employee.hts).length>0 && !isCurrentJobHTS(employee.hts)), 'c-tag-btn u-btn-green':(Object.keys(employee.hts).length==0),'c-tag-btn u-btn-yellow1':(employee.next_vacation.length&&employee.next_vacation[0].vacation_interval)}">
                                <span v-if="employee.next_vacation.length&&employee.next_vacation[0].vacation_interval">
                                    {{getNextVacationTime(employee.next_vacation)}}
                                </span>
                                <span v-else>Next call: 24:00+</span>
                            </a>
                        </li>

                        <li v-if="Object.keys(employee.next_calls).length!=0" :class="{'o-half-div':  true, 'o-half-div-width': !isCurrentJobHTS(employee.hts)}">
                            <a href="javascript: void(0)" :class="{'c-tag-btn u-btn-blue':(Object.keys(employee.hts).length>0 && isCurrentJobHTS(employee.hts)),'c-tag-btn u-btn-light-orange':(Object.keys(employee.hts).length>0 && !isCurrentJobHTS(employee.hts)),'c-tag-btn u-btn-green':(Object.keys(employee.hts).length==0 && !checkTurnOver(employee.next_calls)),'c-tag-btn u-btn-yellow':(Object.keys(employee.hts).length==0 && checkTurnOver(employee.next_calls)),'c-tag-btn u-btn-yellow1':(employee.next_vacation.length&&employee.next_vacation[0].vacation_interval),'u-btn-border-red':checkPrevNextCallSameDay(employee.next_Call)}">
                                <span v-if="employee.next_vacation.length&&employee.next_vacation[0].vacation_interval">
                                    {{ getNextCallTime(employee.next_calls) }} <br />
                                    {{ getNextVacationTime(employee.next_vacation) }}
                                </span>
                                <span v-else>{{ getNextCallTime(employee.next_calls) }} </span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            <div v-else-if="employee.bookings.length>0 && !checkVacationWithinCall(employee.vacations) && !recurringUnavailability(employee.available_times)" class="table-td-border-right calls-table-cell-inner-table">
                <div class="o-tags u-no-padding text-right o-tag-btn-container">
                    <ul class="o-tag-btn-area o-float-right">
                        <li class="o-half-div" v-if="!checkAssignedJob(employee)">
                            <a href="javascript: void(0)" :class="checkThisClickCooking(employee.bookings)?'c-tag-btn u-btn-orange':'c-tag-btn u-btn-red'">
                            {{checkThisClickCooking(employee.bookings)?employee.bookings[0].job_name+ ':' +getConflictDate(employee.bookings[0].start)+'('+getTime(employee.bookings[0].start) +'-'+ getTime(employee.bookings[0].end)+')':'OTHER BOOKING'}}
                            </a>
                        </li>

                        <li class="o-half-div" v-else>
                            <a href="javascript: void(0)" class="c-tag-btn u-btn-blue">
                            {{employee.bookings[0].job_name+ ':' +getConflictDate(employee.bookings[0].start)+'('+getTime(employee.bookings[0].start) +'-'+ getTime(employee.bookings[0].end)+')'}}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            <div v-else-if="!checkVacationWithinCall(employee.vacations) && !recurringUnavailability(employee.available_times)" class="table-td-border-right calls-table-cell-inner-table">
                <div class="o-tags u-no-padding text-right o-tag-btn-container">
                    <ul v-if="getDeclineStatus(employee.call_actions)" class="o-tag-btn-area o-float-right">
                        <li class="o-half-div" @click="openDeclinedModal(employee)">
                            <a href="javascript: void(0)" class="c-tag-btn u-btn-red">
                                Declined : {{getCallActionByType(employee.call_actions, "Declined")[0].job_name}}
                            </a>
                        </li>
                    </ul>

                    <ul v-else-if="!getDeclineStatus(employee.call_actions) && getCallOutStatus(employee.call_actions) && !getTimeOutStatus(employee.call_actions)" class="o-tag-btn-area o-float-right">
                        <li class="o-half-div">
                            <a href="javascript: void(0)" class="c-tag-btn u-btn-yellow">
                                Called Out : {{getCallActionByType(employee.call_actions, "Call Out")[0].job_name}}
                            </a>
                        </li>
                    </ul>

                    <ul v-else-if="!getDeclineStatus(employee.call_actions) && getTimeOutStatus(employee.call_actions) && !getPassStatus(employee.call_actions)" class="o-tag-btn-area o-float-right">
                        <li class="o-half-div">
                            <el-tooltip content="Declined Schedule" placement="top" effect="dark">
                                <a href="javascript: void(0)" class="c-tag-btn u-btn-yellow" @click="openTimedOutModal(employee)">
                                    Timed Out : {{getCallActionByType(employee.call_actions, "Timed Out")[0].job_name}}
                                </a>
                            </el-tooltip>
                        </li>
                    </ul>

                    <ul v-else-if="!getDeclineStatus(employee.call_actions) && getPassStatus(employee.call_actions)" class="o-tag-btn-area o-float-right">
                        <li class="o-half-div">
                            <el-tooltip content="Declined Schedule" placement="top" effect="dark">
                                <a href="javascript: void(0)" class="c-tag-btn u-btn-yellow" @click="openPassedModal(employee)">
                                    Passed : {{getCallActionByType(employee.call_actions, "Passed")[0].job_name}}
                                </a>
                            </el-tooltip>
                        </li>
                    </ul>

                </div>
            </div>
        </div>

        <el-dialog title="Schedule" width="85%" :close-on-click-modal="false" custom-class="pass-time-out-modal" :visible.sync="dialogPassedVisible">
            <ScheduleModal :routeEmployeeId="routeEmployeeId" v-if="routeEmployeeId==employee.id" />
        </el-dialog>

        <el-dialog title="Schedule" width="85%" :close-on-click-modal="false" custom-class="pass-time-out-modal" :visible.sync="dialogTimeOutVisible">
            <ScheduleModal :routeEmployeeId="routeEmployeeId" v-if="routeEmployeeId==employee.id" />
        </el-dialog>
	</div>
</template>

<script>
    import dateTimeConvert from '../../../timeConvert&Compare';
    import ScheduleModal from '@/components/scheduleModal.vue';
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import {
        global
    } from '../../../global.js';
    import { bus } from '../../../main';
    import service from '../../../services.js';
    export default {
        props: {
            isSteward: {
                type: Number,
                required: true
            },
            isDispatcher: {
                type: Number,
                required: true
            },
            employee: {
                type: Object,
                required: true
            },
            columnLabel: {
                type: String,
                required: true
            },
            client:{
                type: Object,
                required: true
            },
            selectedSortType:{
                type: String,
                required: true
            },
            callStartTime:{
                type:String,
                required: true
            },
            callEndTime:{
                type:String,
                required: true
            },
            userDateFormat: {
                type:String,
                required: false
            },
            userTimeFormat: {
                type:String,
                required: false
            }
        },
        data() {
            return {
               columnClass:'',
               turnoverTime: '',
                customField1: '',
                customField2: '',
                showCustom: '',
                address:'',
                routeEmployeeId: '',
                modalActionName: '',
                dialogTimeOutVisible: false,
                dialogPassedVisible: false
            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
                userID: 'userID',
                userRoleSlug: 'userRoleSlug',
                employeeId: "employeeId",
                bulkCallStartTime: 'bulkCallStartTime',
                bulkCallEndTime: 'bulkCallEndTime'
            })
        },
        components: {
            ScheduleModal
        },
        methods: {
            openPassedModal(employee) {
                this.routeEmployeeId = employee.id;
                this.modalActionName = 'passed';
                this.$forceUpdate();
                this.dialogPassedVisible = true;
            },
            closeModal(name) {
                this.modalActionName='';
                this.dialogPassedVisible = false;
                this.dialogTimeOutVisible = false;
                this.routeEmployeeId = '';
            },
            openTimedOutModal(employee) {
                this.routeEmployeeId=employee.id;
                this.modalActionName='timed-out';
                this.$forceUpdate();
                this.dialogTimeOutVisible = true;
            },
            checkPrevNextCallSameDay(dateTime) {
                let prevDate = moment(dateTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
                let callStartDate = '';
                let callEndDate = '';
                if(this.$route.name == 'bulkAssignCustom') {
                    callStartDate = moment(this.bulkCallStartTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
                    callEndDate = moment(this.bulkCallEndTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
                }else {
                    callStartDate = moment(this.callStartTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
                    callEndDate = moment(this.callEndTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
                }
                if(prevDate==callStartDate||prevDate==callEndDate) {
                    return true;
                }
                return false;
            },
            getClientContactFormat(phone) {
                phone = phone ? phone.toString() : '';
                phone = phone.replace(/-/g, "");
                phone = phone.replace(/ /g, "");
                phone = phone.replace("(", "");
                phone = phone.replace(")", "");
                let result = '';
                if(phone&&phone.length==10) {
                    result = '+1'+phone;
                }else if(phone&&phone.length==11) {
                    result = '+' + phone;
                }else if(phone&&phone.length) {
                    result = phone;
                }
                return result;
            },
            getRoundOffSkillSeniority(seniorityVal) {
                if(seniorityVal && seniorityVal != '') {
                    if(seniorityVal.valueOf() == parseInt(seniorityVal)){
                        let x = parseInt(seniorityVal);
                        return x;
                    }
                }
                return seniorityVal;
            },
            async openDeclinedModal(emp) {
                if((this.userRoleSlug != 'employee') || (this.userRoleSlug == 'employee' && (this.isDispatcher || this.isSteward))) {
                    await this.$confirm('Do you want to Un-Decline', 'Un-Decline?', {
                    confirmButtonText: 'Undecline',
                    cancelButtonText: 'Cancel',
                    }).then(async () => {
                        await this.undeclinedCall(emp);
                    }).catch(() => {});
                }
            },

            async undeclinedCall(emp) {
                await service.post('call/undecline', {
                    'employee_id': emp.id,
                    'call_id': this.getDeclinedCallId(emp.call_actions),
                    'user_id': this.userID
                }, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                }).
                then((res) => {
                    let action = 'Decline'
                    this.$Progress.finish();
                    this.$notify({
                        title: 'Success',
                        message: 'Call undeclined successfully.',
                        type: 'success'
                    });
                    bus.$emit('callUnDecline', action );
                }).catch((err) => {
                    console.log(err);
                    this.$notify({
                        title: 'Warning',
                        message: 'Call undeclined Failed.',
                        type: 'warning'
                    });
                    this.$Progress.finish();
                });
            },

            getDeclinedCallId(data) {
                let call_id = data[0].call_id;
                if(data.length > 1) {
                    for(let i=0; i<data.length; i++) {
                        if(data[i].action_name == "Declined") {
                            call_id = data[i].call_id
                        }
                    }
                }
                return call_id;
            },

            isCurrentJobHTS(hts_list){
                if(hts_list && !Array.isArray(hts_list)){
                    hts_list=Object.values(hts_list)
                }
                let flag=false;
                hts_list.forEach(hts => {
                    if(hts.job_id == atob(this.$route.params.id)){
                        flag=true;
                    }
                });
                return flag;
            },
          
            isCurrentHTSJob(hts_job_id) {
                if (hts_job_id == atob(this.$route.params.id)) {
                    return true;
                }
                return false;
            },

            getJobTitle(hts_list){
                if(hts_list && !Array.isArray(hts_list)){
                    hts_list=Object.values(hts_list)
                }
                return (hts_list && hts_list.length? hts_list[0].job_name :'');
            },
            getCallActionByType(call_action, type){
                let declines = [], passes = [], timeouts = [], callouts = [];
                if(call_action && call_action.length){
                    call_action.forEach(call => {
                        switch(call.action_name){
                            case 'Declined':
                                declines.push(call);
                            break;
                            case 'Call Out':
                                callouts.push(call);
                            break;
                            case 'Timed Out':
                                timeouts.push(call);
                            break;
                            case 'Passed':
                                passes.push(call);
                            break;

                            default:
                                // console.log('call Action not found switch 1')
                        }
                    });
                }
                switch(type){
                    case 'Declined':
                        return declines;
                    case 'Call Out':
                        return callouts;
                    case 'Timed Out':
                        return timeouts;
                    case 'Passed':
                        return passes;
                    default:
                        // console.log('call Action not found switch 2')
                }
                return [];
            },
            checkThisClickCooking(bookings,conflicts){
               if(conflicts) {}
               if(bookings.length>0 && bookings[0].client_id == this.userClientID){
                    return true;
                }
                return false;
            },

            checkAssignedJob(employee) {
                let bookings = employee.bookings;
                if(bookings.length>0 && bookings[0].client_id == this.userClientID &&  bookings[0].job_id == atob(this.$route.params.id)){
                    return true;
                }
                return false;
            },

            getParticipation(data){
                var result = 0;
                if(data != null && data != '')
                    result = Math.round(Number(data).toFixed(2) * 100) / 100;
                return result;
            },

            getParticipationJulyJune(data){
                var result = 0;
                if(data != null && data != '')
                    result = Math.round(Number(data).toFixed(2) * 100) / 100;
                return result;
            },

            getDeclineStatus(call_actions){
                let data = this.getCallActionByType(call_actions, "Declined");
                if((data.length>0 || Object.keys(data).length>0)){
                    return true;
                }
                return false;
            },

            getTimeStampValue(data){
                if(data)  return dateTimeConvert.utcTimeToUserTime(data);
                return '- - -';
            },

            getTimeStamp(data){
                if(data)  return moment(data).format('MM/DD/YYYYY @HH:mm:ss');
                return '- - -';
            },

            getGloabalDateTimeFormat(data) {
                if (!data || data === "0000-00-00 00:00:00" || isNaN(new Date(data).getTime())) {
                    return ""; 
                }
                return dateTimeConvert.globalDateTime2(data,this.userDateFormat,this.userTimeFormat);
            },

            getGloabalDateFormat(data) {
                if (!data || data === "0000-00-00 00:00:00" || isNaN(new Date(data).getTime())) {
                    return "";
                }
                return dateTimeConvert.globalDate2(data,this.userDateFormat);
            },

            getPassStatus(call_actions){
                let data = this.getCallActionByType(call_actions, "Passed");
                if ((data.length > 0 || Object.keys(data).length>0)) {
                    return true;
                }
                return false;
            },

            getTimeOutStatus(call_actions){
                let data = this.getCallActionByType(call_actions, "Timed Out");
                if ((data.length > 0 || Object.keys(data).length>0)) {
                    return true;
                }
                return false;
            },

            getCallOutStatus(call_actions){
                let data = this.getCallActionByType(call_actions, "Call Out");
                if ((data.length > 0 || Object.keys(data).length>0)) {
                    return true;
                }
                return false;
            },

            getCustomField(data) {
                var customFld = JSON.parse(data);
                let re = -1;
                let re2 = -1;
                if(customFld && customFld.value)
                {
                    re = customFld.value.search('{\"name\":');
                    let inner = "";
                    if(re>=0) {
                        inner = JSON.parse(customFld.value);
                        if(inner&&inner != ''&&inner.value)
                            re2 = customFld.value.search('{\"name\":')
                        if(inner.value == "{}" || inner.value == "NULL" || inner.value == "null" || inner.value == "Null" || re2>=0)
                            return '';
                        return inner.value;
                    }else
                    return customFld&&customFld.value&& customFld.value !='{}' && customFld.value !='NULL' && customFld.value!='Null' && customFld.value != 'null' ? customFld.value : '';
                }
                return "";
            },

            employeeSummary() {
                this.$modal.show('employeeSummary');
            },

            hideModal() {
                this.$modal.hide();
            },

            getTime(dateTime) {
                return dateTimeConvert.localTime(dateTime);
            },

            getConflictDate(dateTime) {
                return dateTimeConvert.localDate(dateTime, 'DD MMM');
            },

            checkTurnOver(calls){
                if(calls && Object.keys(calls).length){
                    let duration = calls[0].call_interval.split(':');
                    if(duration.length>=2 && Number(duration[0]) <= 24){
                        let hours =  Number(duration[0]);
                        if(hours < this.turnoverTime){
                            return true;
                        }
                    }
                }
                return false;
            },

            getPrevCallTime(calls) {
                if(calls && Object.keys(calls).length){
                    let duration = calls[0].call_interval.split(':');
                    if(duration.length >= 3 && Number(duration[0]) < 24){
                        return 'Last call '+moment(calls[0].call_interval, 'HH:mm:ss').format('HH:mm')+'+';
                    }
                }
                return "Last call 24:00+";
            },
            getPrevCallDateTime(dateTime) {
                let result = "24:00+"
                if(dateTime&&dateTime!='') {
                    result = this.getGloabalDateTimeFormat(dateTime)
                }
                return result;
            },
            getNextCallDateTime(dateTime) {
                let result = "24:00+"
                if(dateTime&&dateTime!='') {
                    result = this.getGloabalDateTimeFormat(dateTime)
                }
                return result;
            },
            getNextVacationAndCallTime(vacation,calls) {
                let result1 = '';
                let result2 = '';
                if(calls && Object.keys(calls).length){
                    let duration = calls[0].call_interval.split(':');
                    if(duration.length >= 3 && Number(duration[0]) < 24){
                        result1 =  'Next call '+moment(calls[0].call_interval, 'HH:mm:ss').format('HH:mm')+'+';
                    }
                }
                if(vacation && Object.keys(vacation).length){
                    let duration = vacation[0].vacation_interval.split(':');
                    if(duration.length >= 3 && Number(duration[0]) < 24){
                        result2 = 'Next vacation: '+moment(vacation[0].vacation_interval, 'HH:mm:ss').format('HH:mm')+'+';
                    }
                }
                return result1 + ', ' + result2;
            },

            getNextVacationTime(calls) {
                if(calls && Object.keys(calls).length){
                    let duration = calls[0].vacation_interval.split(':');
                    if(duration.length >= 3 && Number(duration[0]) < 24){
                        return 'Next vacation '+moment(calls[0].vacation_interval, 'HH:mm:ss').format('HH:mm')+'+';
                    }
                }
                return "Next call 24:00+";
            },
            getNextCallTime(calls) {
                if(calls && Object.keys(calls).length){
                    let duration = calls[0].call_interval.split(':');
                    if(duration.length >= 3 && Number(duration[0]) < 24){
                        return 'Next call '+moment(calls[0].call_interval, 'HH:mm:ss').format('HH:mm')+'+';
                    }
                }
                return "Next call 24:00+";
            },

            // removed the unused code for unavailability on 02-02-2023 20:30:00
            recurringUnavailability(unavailability_list) {
                var flag=false;
                let weekDaysNumbers = ["1","2","3","4","5","6","7"];
                let weekDaysNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
                if(unavailability_list && Object.keys(unavailability_list).length){
                    let unavailabilityList = JSON.parse(unavailability_list);
                    for(let i=0; i<weekDaysNumbers.length; i++) {
                        let unavailabilityList1=unavailabilityList[weekDaysNumbers[i]];
                        for(var j=1; j<=Object.keys(unavailabilityList1).length; j++){
                            var temp = unavailabilityList1[j];
                            var start = this.callStartTime.split(' ')[0]+' '+temp[0]+':00';
                            var end = this.callStartTime.split(' ')[0]+' '+temp[1]+':00';

                            let isOvernightUnavailability = moment(start,'YYYY-MM-DD HH:mm:ss').isAfter(moment(end,'YYYY-MM-DD HH:mm:ss'));

                            if(isOvernightUnavailability) {
                                end = moment(end, 'YYYY-MM-DD HH:mm:ss').add(1, "d").format("YYYY-MM-DD HH:mm:ss");
                                let day1UnavailabilityStart = moment(start, 'YYYY-MM-DD HH:mm:ss').format("YYYY-MM-DD HH:mm:ss");
                                let tempDay1UnavailabilityEnd = moment(start, 'YYYY-MM-DD HH:mm:ss').format("YYYY-MM-DD") + ' ' + '23:59:59';
                                let day1UnavailabilityEnd = moment(tempDay1UnavailabilityEnd, 'YYYY-MM-DD HH:mm:ss').format("YYYY-MM-DD HH:mm:ss");
                                let tempDay2UnavailabilityStart = moment(end, 'YYYY-MM-DD HH:mm:ss').format("YYYY-MM-DD") + ' ' + '00:00:00';
                                let day2UnavailabilityStart = moment(tempDay2UnavailabilityStart, 'YYYY-MM-DD HH:mm:ss').format("YYYY-MM-DD HH:mm:ss");
                                let day2UnavailabilityEnd = moment(end, 'YYYY-MM-DD HH:mm:ss').format("YYYY-MM-DD HH:mm:ss");

                                flag = this.checkCallDateUnavailability(day1UnavailabilityStart, day1UnavailabilityEnd, this.callStartTime, this.callEndTime, weekDaysNames[i],temp);
                                if(flag) return flag;

                                let dayIndex = i;
                                if(i==6) dayIndex=-1;

                                flag = this.checkCallDateUnavailability(day1UnavailabilityStart, day1UnavailabilityEnd, this.callStartTime, this.callEndTime, weekDaysNames[dayIndex+1],temp);
                                if(flag) return flag;

                                flag = this.checkCallDateUnavailability(day2UnavailabilityStart, day2UnavailabilityEnd, this.callStartTime, this.callEndTime, weekDaysNames[dayIndex+1],temp);
                                if(flag) return flag;
                            }else {
                                if((moment(this.callStartTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') != moment(this.callEndTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'))) {
                                    let day1CallStart = moment(this.callStartTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
                                    let tempDay1CallEnd =  moment(this.callStartTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') + ' ' + '23:59:59'
                                    let day1CallEnd = moment(tempDay1CallEnd,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');

                                    let tempDay2CallStart =  moment(this.callEndTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') + ' ' + '00:00:00'
                                    let day2CallStart = moment(tempDay2CallStart,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
                                    let day2CallEnd = moment(this.callEndTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');

                                    if(moment(day1CallStart,'YYYY-MM-DD HH:mm:ss').format('dddd') == weekDaysNames[i]){
                                        start = day1CallStart.split(' ')[0]+' '+temp[0]+':00';
                                        end = day1CallStart.split(' ')[0]+' '+temp[1]+':00';
                                        flag = dateTimeConvert.dateCheck(start,end, day1CallStart, day1CallEnd);
                                        if(flag) return flag;
                                    }else if(moment(day2CallStart,'YYYY-MM-DD HH:mm:ss').format('dddd') == weekDaysNames[i]) {
                                        start = day2CallStart.split(' ')[0]+' '+temp[0]+':00';
                                        end = day2CallStart.split(' ')[0]+' '+temp[1]+':00';
                                        flag = dateTimeConvert.dateCheck(start,end, day2CallStart, day2CallEnd);
                                        if(flag) return flag;
                                    }
                                }else {
                                    if(moment(this.callStartTime,'YYYY-MM-DD HH:mm:ss').format('dddd') == weekDaysNames[i]) {
                                        flag = dateTimeConvert.dateCheck(start,end, this.callStartTime, this.callEndTime);
                                        if(flag) return flag;
                                    }
                                }
                            }
                        }
                    }
                }
                return flag;
            },

            checkCallDateUnavailability(start, end, callStartTime, callEndTime, day,temp) {
                let flag = false;
                if((moment(callStartTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') != moment(callEndTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'))) {
                    let day1CallStart = moment(callStartTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
                    let tempDay1CallEnd =  moment(callStartTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') + ' ' + '23:59:59'
                    let day1CallEnd = moment(tempDay1CallEnd,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');

                    let tempDay2CallStart =  moment(callEndTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') + ' ' + '00:00:00'
                    let day2CallStart = moment(tempDay2CallStart,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
                    let day2CallEnd = moment(callEndTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');

                    if(moment(day1CallStart,'YYYY-MM-DD HH:mm:ss').format('dddd') == day){
                        start = day1CallStart.split(' ')[0]+' '+temp[0]+':00';
                        end = day1CallStart.split(' ')[0]+' '+temp[1]+':00';
                        flag = dateTimeConvert.dateCheck(start,end, day1CallStart, day1CallEnd);
                        if(flag) return flag;
                    }else if(moment(day2CallStart,'YYYY-MM-DD HH:mm:ss').format('dddd') == day) {
                        start = day2CallStart.split(' ')[0]+' '+temp[0]+':00';
                        end = day2CallStart.split(' ')[0]+' '+temp[1]+':00';
                        flag = dateTimeConvert.dateCheck(start,end, day2CallStart, day2CallEnd);
                        if(flag) return flag;
                    }
                }else {
                    if(moment(callStartTime,'YYYY-MM-DD HH:mm:ss').format('dddd') == day) {
                        flag = dateTimeConvert.dateCheck(start,end, callStartTime, callEndTime);
                        if(flag) return flag;
                    }
                }
                return flag;
            },

            recurringUnavailability1(unavailability_list){  //removed... not calling any where, just for reference
                let flag=false;
                if(unavailability_list && Object.keys(unavailability_list).length){
                    let unavailabilityList = JSON.parse(unavailability_list);
                    let dayNum1=moment(this.callStartTime).format('d');

                    dayNum1=Number(dayNum1)+1;
                    let unavailabilityList1=unavailabilityList[dayNum1];
                    for(var i=1; i<=Object.keys(unavailabilityList1).length; i++){
                        var temp = unavailabilityList1[i];
                        var start = this.callStartTime.split(' ')[0]+' '+temp[0]+':00';
                        var end = this.callStartTime.split(' ')[0]+' '+temp[1]+':00';
                        if(dateTimeConvert.dateCheck(start, end, this.callStartTime, this.callEndTime)){
                            flag=true;
                            return flag;
                        }
                    }
                    let dayNum2=moment(this.callEndTime).format('d');
                    dayNum2=Number(dayNum2)+1;
                    if(this.callStartTime.split(' ')[0] != this.callEndTime.split(' ')[0]) {
                        let unavailabilityList2=unavailabilityList[dayNum2];
                        for(var i=1; i<=Object.keys(unavailabilityList2).length; i++){
                            var temp = unavailabilityList2[i];
                            var start = this.callEndTime.split(' ')[0]+' '+temp[0]+':00';
                            var end = this.callEndTime.split(' ')[0]+' '+temp[1]+':00';
                            if(dateTimeConvert.dateCheck(start, end, this.callStartTime, this.callEndTime)){
                                flag=true;
                                return flag;
                            }
                        }
                    }
                }
                return flag;
            },
            checkVacationWithinCall(vacations) {

                if(vacations.length>0){
                    return true;
                }else{
                    return false;
                }
            },
        },
        created() {
            switch(this.columnLabel){
                case "skill_seniority":
                    this.columnClass='calls-table-cell tcell_5'
                    break;
                case "shift_count_total":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "shift_count_ytd":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "declines_total":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "declines_ytd":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "declines_ytd_july_june":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "shifts_this_week":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "employee_cell_phone":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "employee_name":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "conflicts":
                    this.columnClass='calls-table-cell tcell_7'
                    break;
                case "shifts_ytd_july_june":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "location":
                    this.columnClass='calls-table-cell tcell_5'
                    break;
                case "decline_this_week":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "participation":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "participation_july_june_desc":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "member_since":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "date_of_hire":
                    this.columnClass='calls-table-cell tcell_4'
                    break;

                case "last_offer":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "last_assigned":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "last_confirmed":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "wishlist":
                    this.columnClass='calls-table-cell tcell_3'
                    break;
                case "employee_seniority":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "custom_field1":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "custom_field2":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
            }
            this.turnoverTime = this.client.turnover;
            // this.selectedSortType = this.client.default_sort;
            this.customField1 = this.client.custom_field_1;
            this.customField2 = this.client.custom_field_2;
            this.showCustom = this.client.call_assignment_title;
            this.callAssigmentSettings = this.client.settings['call-assignment-config'];
        }

    }

</script>
<style scoped>
.o-common-modal-content {
    padding-bottom: 15px !important;
}
.phone-number-display{
    padding: 5px;
    cursor: pointer;
    color: #222222;
    text-decoration: none !important;
}
.u-btn-blue {
    background: #37bae8!important;
}

.u-btn-yellow1 {
    background: #e8e000bf!important;
}
.u-btn-text-red1 {
    color: red!important;
}
.u-btn-border-red {
    border: solid 5px red;
}
.o-half-div-width{
    width: auto;
}
</style>

<style>
.el-dialog.pass-time-out-modal {
    border: 2px solid #000000;
    border-radius: 5px;
}
.pass-time-out-modal .el-dialog__header {
    padding: 0;
    margin-top: 0px;
    /* display: none; */
    /* border-bottom: 2px solid #000000; */
}
.pass-time-out-modal .el-dialog__body {
    padding: 0;
}
.pass-time-out-modal .el-dialog__body .o-main-content-area2 {
    padding: 20px 20px 0;
}
.pass-time-out-modal .el-dialog__body .o-main-content-area2 .employee-summary-profile{
    text-align: left;
}
.pass-time-out-modal .el-dialog__body .o-main-content-area2 .employee-summary-profile--inline{
    margin: 0;
}
.pass-time-out-modal .el-dialog__body .o-ndividualTable {
    padding: 0 20px 10px!important;
}
.pass-time-out-modal .el-dialog__body .o-main-content-area2 .c-common-space {
    margin-bottom: 0!important;
}
.pass-time-out-modal .el-dialog__body .o-main-content-area2 .o-inline-datepicker-icon {
    width: 160px!important;
}
.pass-time-out-modal .el-dialog__body .o-main-content-area2 .o-schedule-month a {
    /* font-size: 18px; */
    /* color: #4D7FAE; */
    margin-left: 2px;
}
.pass-time-out-modal .el-dialog__body .o-main-content-area2 .o-filter-area {
    margin-right: 32px;
}
.pass-time-out-modal .el-dialog__body .o-ndividualTable .o-schedule-table {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
}
.pass-time-out-modal .el-dialog__header .el-dialog__headerbtn {
    top: 0;
    right: 0;
    padding: 10px;
    background-color: #fc3b3b;
    color: #ffffff;
    z-index: 999;
}

.pass-time-out-modal .el-dialog__header .el-dialog__title {
    display: none;
    /* font-size: 24px; */
    /* color: #000000; */
    /* font-weight: bold; */
}
.pass-time-out-modal .el-dialog__header .el-dialog__headerbtn .el-icon-close {
    color: #ffffff;
    font-weight: bold;
}
.pass-time-out-modal .el-dialog__header .el-dialog__headerbtn .el-icon-close:hover {
    color: #ffffff!important;
    font-weight: bold;
}
/* .pass-time-out-modal {
    border: 2px solid #000000;
    border-radius: 5px;
} */
</style>
